module.exports = __webpack_public_path__ + "img/selectDropdown.4e860321.svg";